import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { get } from 'lodash';
import PropTypes from 'prop-types';
import TrackableLink from "../TrackableLink/TrackableLink";
import styles from "./NewStaticMapWidget.less";
import tracking from "../../tracking/tracking";
import { SEARCH_PRICE_MAP } from "../../tracking/trackingNaming";
import {
  getAddress,
  getGeoHierarchy,
  getHierarchyLevel,
  getRealEstateType, getShapeServicesUrl, getTopLevelDomain
} from "../../selectors/selectors";
import { GEO_HIERARCHY_LEVELS } from "../../utils/globals";
import { getLinkFromAddress, loadLinkFromHierarchy } from "./linkToSearch";

const NewStaticMapWidget = ({ isNewPageConcept, hierarchyLevel, address, realEstateType, geoHierarchy, topLevelDomain, shapeServiceUrl }) => {
  const [ linkUrl, setLinkUrl ] = useState('');
  const shapeID = geoHierarchy[geoHierarchy.length - 1].id;
  useEffect(() => {
    if (hierarchyLevel === GEO_HIERARCHY_LEVELS.street || hierarchyLevel === GEO_HIERARCHY_LEVELS.address) {
      const linkFromAddress = getLinkFromAddress(topLevelDomain, hierarchyLevel, address, realEstateType);
      setLinkUrl(linkFromAddress);
    } else {
      loadLinkFromHierarchy(shapeID, shapeServiceUrl, topLevelDomain, realEstateType).then((result) => {
        if (result.hierarchicSearchUrl) {
          setLinkUrl(result.hierarchicSearchUrl);
        }
      });
    }
  }, [
    hierarchyLevel,
    address.zipcode,
    address.city,
    address.street,
    address.houseNumber,
    address.district,
    get(address, 'position.lat'),
    get(address, 'position.lng'),
    shapeID,
    realEstateType,
    topLevelDomain,
    shapeServiceUrl]);

  const renderContent = () => {
    return (
      <div className={styles.staticImageContainer} id="staticMapWidget">
        { linkUrl && <button className={`button-secondary ${styles.centeredButton}`}>Zur Preiskarte</button>}
      </div>
    );
  };
  const renderWithLink = () => {
    if (linkUrl) {
      return <TrackableLink href={linkUrl} onClick={() => tracking.report(SEARCH_PRICE_MAP)}>
        { renderContent() }
      </TrackableLink>
    }

    return <div>
      { renderContent() }
    </div>
  }

  if (isNewPageConcept) {
    return <div className={styles.frameNewPageConcept}>{ renderWithLink() }</div>
  }

  return <div className="border">{ renderWithLink()}</div>;

};

NewStaticMapWidget.defaultProps = {
  isNewPageConcept: PropTypes.bool
};

const mapStateToProps = (state) => ({
  hierarchyLevel: getHierarchyLevel(state),
  address: getAddress(state),
  realEstateType: getRealEstateType(state),
  geoHierarchy: getGeoHierarchy(state),
  topLevelDomain: getTopLevelDomain(state),
  shapeServiceUrl: getShapeServicesUrl(state)
});

export default connect(mapStateToProps)(NewStaticMapWidget);
